import * as React from "react";

import { useSelector } from "react-redux";
import * as moment from "moment";

import { ApplicationState } from "../../applicationState";
import { selectors as employeeRecordSelectors } from "../../crud/employeeRecord";
import { selectors as ohCaseSelectors } from "../../crud/ohCase";

export const EmployeeRecordBanner: React.FC = () => {
    // don't show banner on a route used for pdf generation
    const isPdfRoute = useSelector(
        (state: ApplicationState) => state.router.routes && state.router.routes[(state.router as any).route].isPdfRoute);

    const ohCase = useSelector(ohCaseSelectors.ohCase);

    const employeeRecord = useSelector(employeeRecordSelectors.employeeRecord);

    // don't show banner on the ohCase page as we might need to show the imms banner
    if (ohCase || isPdfRoute || !employeeRecord) {
        return null;
    }

    if (employeeRecord.terminationDate?.isSameOrBefore(moment().startOf("day")) ?? false) {
        return (
            <div className="employee-terminated-banner">
                This employee record has been terminated.
            </div>
        );
    }

    if (!employeeRecord.active) {
        return (
            <div className="employee-inactive-banner">
                This employee record is inactive.
            </div>
        );
    }

    return null;
};
